import * as React from 'react';
import Image from 'next/image';

import { RestaurantMenu } from '@/lib/types/customer/restaurant/StoreProfile';

interface MenuCardProps {
  item: RestaurantMenu;
}

export const MenuCard = (props: MenuCardProps) => {
  const { item } = props;
  return (
    <div
      className="col-span-12 flex items-start space-x-0 rounded-[5px] border border-[#E5E7EB] bg-white p-[20px] transition-shadow hover:shadow-[0px_7px_30px_0px_rgba(0,0,0,0.13)] sm:col-span-6 sm:flex-row "
      key={item.id}
    >
      {item?.media?.image && (
        <div className="relative mr-4 h-[87px] w-[87px] overflow-hidden rounded-[5px] border border-neutral-100 sm:mr-5">
          <Image
            src={item.media.image[0].thumb_url}
            fill
            style={{ objectFit: 'cover' }}
            alt={item.name + 'cover image'}
            // width={87}
            // height={87}
            // alt={item.name}
            // className="rounded"
          />
        </div>
      )}
      <div className="space-y-3">
        <div className="space-y-2">
          <h4 className="font-700 w-full text-h6 text-title sm:max-w-[200px]">
            {item.name}
          </h4>
          {/* <h5 className="menu-desc text-sm leading-[130%]">
            {item.description}
          </h5> */}
        </div>
        <div className="menu-price text-lg font-[700] text-title">
          {/* {formatNumber({ value: item.price })} */}
          {item.formatted_currency.price}
        </div>
      </div>
    </div>
  );
};
